<template>
  <v-layout
    class="empty-state"
    align-center
    justify-center
    column
    fill-height
  >
    <img
      :src="imageSrc"
      :alt="!$slots.default ? $t(`${namespace}.${type}.text`) : null"
      class="empty-state__img"
      :style="imageSize ? `width: ${imageSize}px` : null"
    >

    <slot v-if="$slots.default" />

    <p
      v-else
      v-html="$t(`${namespace}.${type}.text`)"
      class="empty-state__text"
    />
  </v-layout>
</template>

<script>
import employee from './img/employee.svg'
import car from './img/car.svg'
// import ride from './img/ride.svg'
import employees from './img/employees.svg'
import phone from './img/phone.svg'

export default {
  name: 'EmptyState',
  props: {
    type: {
      type: String,
      default: 'ride'
    },
    imageSize: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      namespace: 'Components.EmptyState',
      imageSrc: null
    }
  },
  methods: {
    renderHtml () {
      switch (this.type) {
        case 'employee':
          this.imageSrc = employee
          return

        case 'ride':
          this.imageSrc = car
          return

        case 'phone':
          this.imageSrc = phone
          return

          // case '':
          //   return

          // case '':
          //   return

        default:
          this.imageSrc = employees
      }
    }
  },
  watch: {
    image () {
      this.renderHtml()
    },
    imageSize () {
      this.renderHtml()
    }
  },
  mounted () {
    this.renderHtml()
  }
}
</script>

<style lang="scss" scoped>
.empty-state {
  text-align: center;
}

.empty-state__img {
  margin-bottom: 16px;
}

.empty-state__text {
  margin-bottom: 0;
}
</style>
